import {h, Component} from 'preact';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import q from 'q';
import axios from 'axios';

import UserAuth from '../services/userAuth';
import Util from '../services/util';
import Login from './login/login';
import ForgetPassword from './reset-password/forget-password';
import ResetPassword from './reset-password/reset-password';
import ResetTempPassword from './reset-temp-password/reset-temp-password';
import PasswordExpired from './change-password/password-expired';
import ChangePassword from './change-password/change-password';
import Verification from './two-factor/verification';
import PhoneAuth from './two-factor/phone-auth';
import Symantec from './two-factor/symantec';
import asyncComponent from './tags/async-component';

/* istanbul ignore next */
const Design = asyncComponent(() =>
    import('./design/design').then(module => module.default)
);
/* istanbul ignore next */
const InstallerError = asyncComponent(() =>
    import('./errors/installer-error').then(module => module.default)
);
/* istanbul ignore next */
const SupportForm = asyncComponent(() =>
    import('./help/support-form').then(module => module.default)
);
/* istanbul ignore next */
const SessionStatus = asyncComponent(() =>
    import('./session-status/session-status').then(module => module.default)
);
/* istanbul ignore next */
const MobileOnboardingNotSupported = asyncComponent(() =>
    import('./errors/mobile-onboarding-not-supported').then(module => module.default)
);
/* istanbul ignore next */
const MobileWizard = asyncComponent(() =>
    import('./mobile-setup/mobile-wizard').then(module => module.default)
);
/* istanbul ignore next */
const MobileSetup = asyncComponent(() =>
    import('./mobile-setup/mobile-setup').then(module => module.default)
);

// track pages on route change
// const onChange = obj => window.ga && ga.send('pageview', { dp:obj.url });

const basename = process.env.basename;

class App extends Component {
    constructor() {
        super();
        this.q = q;
        axios.interceptors.request.use((config) => {
            // Do something with request data
            //add touchable header
            if (('ontouchstart' in window) ||
                (navigator.maxTouchPoints > 0) ||
                (navigator.msMaxTouchPoints > 0)) {
                config.headers['x-touch-supported'] = true;
            }
            return config;
        }, (error) => {

        });
    }

    componentDidMount() {
        localStorage.removeItem('wpInActiveSession');
        if (Util.isMobile()) {
            document.getElementsByTagName( 'html' )[0].classList.add('phone-view');
        }
        window.addEventListener("beforeunload", App.onPageRefresh)
    }

    componentWillUnmount() {
        window.removeEventListener("beforeunload", App.onPageRefresh)
    }

    static onPageRefresh() {
        UserAuth.clearAuthSessionStorage();
    }

    render({}, {}) {
        return(
            <div id='root'>
                <div className='container-wrapper'>
                    <BrowserRouter basename={basename}>
                        <Switch>
                            {process.env.NODE_ENV && process.env.NODE_ENV === 'development' ? (
                                <Route exact path='/design' component={Design}/>
                            ) : null}
                            <Route exact path='/installer-error' component={InstallerError}/>
                            <Route exact path='/forget-password' component={ForgetPassword}/>
                            <Route exact path='/reset-password' component={ResetPassword}/>
                            <Route exact path='/reset-temp-password' component={ResetTempPassword}/>
                            <Route exact path='/password-expired' component={PasswordExpired}/>
                            <Route exact path='/change-password' component={ChangePassword}/>
                            <Route exact path='/verification' component={Verification}/>
                            <Route exact path='/phone-auth' component={PhoneAuth}/>
                            <Route exact path='/symantec' component={Symantec}/>
                            <Route exact path='/session-status' component={SessionStatus}/>
                            <Route exact path='/mobile-onboarding-not-supported' component={MobileOnboardingNotSupported}/>
                            <Route exact path='/help/support-form' component={SupportForm}/>
                            <Route exact path='/mobile-wizard' component={MobileWizard}/>
                            <Route exact path='/mobile-setup' component={MobileSetup}/>
                            <Route exact path='/' component={Login}/>
                            <Route component={Login}/>
                        </Switch>
                    </BrowserRouter>
                </div>
            </div>
        )
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/scripts/views/index.js